import { useMutation, useQueries, useQuery, useQueryClient } from '@tanstack/react-query'
import appApiCalls from '../../services/api'

export function useUploadCV() {
    const queryClient = useQueryClient()
    return useMutation((arg) => appApiCalls.uploadUserCV(arg), {
        onSuccess: (data) => {
            queryClient.invalidateQueries(['Fetch User Cvs'])
            return data
        },
    })
}

export function useDeleteCV() {
    const queryClient = useQueryClient()
    return useMutation((arg) => appApiCalls.deleteUserCV(arg), {
        onSuccess: (data) => {
            queryClient.invalidateQueries(['Fetch User Cvs'])
            return data
        },
    })
}

export function useApplyForScholarship() {
    const queryClient = useQueryClient()
    return useMutation((arg) => appApiCalls.applyForScholarship(arg), {
        onSuccess: (data) => {
            queryClient.invalidateQueries(['Apply For Scholarship'])
            return data
        }
    })
}

export function useFetchUserCVs() {
    return useQuery(['Fetch User Cvs'], () => appApiCalls.fetchUserCv(), {
        staleTime: Infinity,
    })
}

export function useGetAllScholarships() {
    return useQuery(['Fetch All Scholarships'], () => appApiCalls.getAllScholarships(), {
        staleTime: Infinity
    })
}
